import { useStore } from "../../components/ApartmentFinder/State/Store"
import ApartmentFinder from "../../components/ApartmentFinder/ApartmentFinder"

const Explore = () => {
  const visible = useStore(state => state.visible)

  return (
    <div
      style={{
        visibility: visible ? "" : "hidden",
        zIndex: 1,
        position: "absolute",
        height: "100%",
        width: "100%"
      }}
    >
      <ApartmentFinder
        staticGeometryID={"st"}
        semiStaticGeometryID={"ss"}
        interactiveBuildingID={"cd"}
        hdriFile="ulmer_muenster_1k"
      />
    </div>
  )
}

export default Explore
